import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
  selector: 'nv-sidebar-item',
  template: require('./nv-sidebar-item.component.html'),
  styles: [require('./nv-sidebar-item.scss')],
  // encapsulation: ViewEncapsulation.Emulated,
})
export class NvSidebarItemComponent {
  /**
   *
   *
   */
  @Input() label: string;

  /**
   *
   *
   */
  @Input() icon: string;

  /**
   *
   *
   */
  @Input() isSelected: boolean = false;

  /**
   *
   *
   */
  @Input() isDisabled: boolean = false;

  /**
   *
   * The icon that displays on the right-hand side.
   * Typically `dropdown` or `caret-down`
   */
  @Input() actionIcon: string;

  /**
   *
   *
   */
  @Output() sidebarItemSelect: EventEmitter<void> = new EventEmitter<void>();

  handleClick(event) {
    this.sidebarItemSelect.emit();
  }
}
